import axios from 'axios';
import appConfig from '../config/main.config';
const apiserv = appConfig.url_api;

export const getCurrencyByCode = (curcode) => {

    //corregir code traer: GET /api/currencies?suffix=USD
    //const api = `${apiserv}/currencies?code=${curcode}`;
    const api = `${apiserv}/currencies`;

    const currency = axios.get(api, { params: {code: curcode}})
        .then(res => {
            //console.log('res data', res.data)
            //return res.data;
            return { ...res.data, ...{ error: false } };
        })
        .catch((error) => {
            //console.log(error.config);
            return {error: true, message: error.response}
        });

    return currency;
}